module.exports = __webpack_public_path__ + "img/CHF.5aab0fc9.svg";